<template>
  <div>
    <el-menu class="navbar" mode="horizontal">
      <hamburger
        class="hamburger-container"
        :toggleClick="toggleSideBar"
        :isActive="sidebar.opened"
      ></hamburger>
      <breadcrumb></breadcrumb>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img class="user-avatar" src="../../../assets/images/icon.png" />
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <!-- <router-link class="inlineBlock" to="/">
            <el-dropdown-item>
              首页
            </el-dropdown-item>
          </router-link> -->
          <el-dropdown-item divided>
            <span @click="logout" style="display: block">退出</span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span @click="showUpdatePasswordDialog" style="display: block"
              >修改密码</span
            >
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-menu>

    <!-- 修改密码对话框 -->
    <el-dialog
      title="修改密码"
      :visible.sync="updatePasswordDialogVisible"
      width="400px"
      @close="handleCancelUpdatePassword"
    >
      <el-form
        :model="passwordForm"
        :rules="passwordRules"
        ref="passwordForm"
        label-width="80px"
      >
        <el-form-item label="新密码" prop="password1">
          <el-input
            v-model="passwordForm.password1"
            type="password"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="password2">
          <el-input
            v-model="passwordForm.password2"
            type="password"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancelUpdatePassword">取 消</el-button>
        <el-button
          type="primary"
          @click="handleUpdatePassword"
          :loading="updatePasswordLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import { updatePassword } from "@/api/login";
import { removeToken } from "@/utils/auth";

export default {
  components: {
    Breadcrumb,
    Hamburger,
  },
  computed: {
    ...mapGetters(["sidebar", "avatar"]),
  },
  data() {
    // 确认密码验证规则
    var validateConfirmPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.passwordForm.password1) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      updatePasswordDialogVisible: false,
      updatePasswordLoading: false,
      passwordForm: {
        password1: "",
        password2: "",
      },
      passwordRules: {
        password1: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, message: "密码长度至少6位", trigger: "blur" },
        ],
        password2: [
          { required: true, message: "请确认新密码", trigger: "blur" },
          { validator: validateConfirmPassword, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    handleCancelUpdatePassword() {
      // 清除表单验证错误
      this.$refs.passwordForm.clearValidate();
      // 关闭对话框
      this.updatePasswordDialogVisible = false;
      this.passwordForm = {
        password1: "",
        password2: "",
      };
    },
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        // 清除本地存储和会话存储
        localStorage.clear();
        sessionStorage.clear();
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    showUpdatePasswordDialog() {
      this.updatePasswordDialogVisible = true;
      this.passwordForm = {
        password1: "",
        password2: "",
      };
    },
    handleUpdatePassword() {
      let that = this;
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          this.updatePasswordLoading = true;
          updatePassword(this.passwordForm)
            .then((response) => {
              this.updatePasswordLoading = false;
              this.$confirm("修改成功，需重新登录", "提示", {
                confirmButtonText: "确定",
                showCancelButton: false,
                type: "success",
              }).then(() => {
                // 调用登出接口并刷新页面
                // 清除系统缓存
                localStorage.clear();
                sessionStorage.clear();
                removeToken();
                location.reload();
                that.updatePasswordDialogVisible = false;
                that.passwordForm = {
                  password1: "",
                  password2: "",
                };
              });
            })
            .catch((err) => {
              this.updatePasswordLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;

  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }

  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }

  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;

    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;

      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }

      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue